import _ from 'lodash';
import ScrollHint from 'scroll-hint';
import 'scroll-hint/css/scroll-hint.css';
import feather from 'feather-icons';
import { Common } from './common';
import { Home } from './Home';
import { Filter } from './components/filter';

(function () {
  window.addEventListener('DOMContentLoaded', () => {
    feather.replace();
    Common.init();
    Home.init();
    Filter.init();
    new ScrollHint('.js-scrollable', {
      applyToParents: false,
      i18n: {
        scrollable: 'スクロールできます',
      },
    });
  });
  const handleResize = _.debounce(() => {
    Common.resize();
    Filter.resize();
  });
  window.addEventListener('resize', handleResize);
  window.addEventListener('breakPoint', () => {
    Common.breakPoint();
  });
})();
